import React from 'react';
import PropTypes from 'prop-types';
import { UiIcon, UiButton } from 'ui-components';
import { useSelector } from 'react-redux';
import { Pagination as MUIPagination, PaginationItem } from '@mui/material';
import { StyledPagination } from './Pagination.styles';

const Pagination = ({
  total,
  currentPage,
  onPageChange,
  pageCount,
  dataTestid,
}) => {
  const pageContentCountSlider = useSelector(
    (state) => state.settingsReducer.filters.public.pageContentCountSlider
  );
  // باید اول تعداد صفحه نرمال محاسبه بشه-برای اینکه تعدد کل محتوا نباید بیشتر از 1000 عدد بشه
  // پس در نتیجه تعداد صفحه باید بر اساس 1000 تا ریزالت محاسبه بشه
  const _pageCount =
    total / (pageCount || pageContentCountSlider.selectedValue || 10);

  return (
    <StyledPagination>
      <MUIPagination
        className='pagination flex'
        data-testid={dataTestid ?? 'pagination'}
        shape='rounded'
        size='large'
        boundaryCount={2}
        count={Math.ceil(
          _pageCount * pageContentCountSlider.selectedValue > 1000 &&
            _pageCount > 100
            ? 100
            : _pageCount
        )}
        page={currentPage}
        onChange={(e, nextPage) => onPageChange(nextPage)}
        renderItem={(item) => {
          if (item.type === 'previous' || item.type === 'next') {
            return (
              <UiButton
                disabled={item.disabled}
                variant='outlined'
                onClick={item.onClick}
                style={{
                  maxWidth: '44px',
                  minWidth: '44px',
                }}
                data-testid={`${dataTestid}-btn-${item.type}`}
              >
                <UiIcon
                  icon={`ri-arrow-${
                    item.type === 'previous' ? 'right' : 'left'
                  }-line`}
                  color='#b5b5b5'
                  data-testid={`${dataTestid}-icon`}
                />
              </UiButton>
            );
          }

          return (
            <PaginationItem {...item} data-testid={`${dataTestid}-item`} />
          );
        }}
      />
    </StyledPagination>
  );
};

Pagination.propTypes = {
  pageCount: PropTypes.number,
  total: PropTypes.number,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func,
  dataTestid: PropTypes.string,
};

export default Pagination;
